import React, { Component } from 'react'
import { Button } from "@driftt/tide-core-legacy"

import { encodeQueryData } from 'utils/Helpers'
import Accordion from 'components/settings/Accordion'
import { popUp } from 'components/Integration/helpers'
import { APP_URL, MICROSOFT_ADMIN_CONSENT_CLIENT_ID } from 'constants/ResourcesConstants'

import OfficeLogo from '../OfficeLogo'
import calendarConnectTeaseSrc from 'images/meetings/tease-calendar-connect.png'

import './style.styl'

const MICROSOFT_CONSENT_BASE_URL = 'https://login.microsoftonline.com/common/adminconsent'

const TitleDescription = (
  <span>
    Take the back and forth out of scheduling and give leads and customers a direct line to your calendar. Let people schedule meetings with you right from chat or email. <a href="https://help.drift.com/article/calendarsetup/" target="_blank" rel="noopener noreferrer">Learn More</a>
  </span>
)

const Header = (
  <div className="settings-global-calendar--connect header">
    <Accordion
      className="global-calendar-title"
      title="My Meetings"
      description={TitleDescription}
      locked={true}/>
  </div>
)

class ConnectGlobalCalendar extends Component {

  state = {
    pending: false
  }

  onCalendarConnectClick = () => {
    this.setState({
      pending: true,
    })

    const params = {
      redirect_uri: `${APP_URL}/accept-integration/office-365-admin-consent`,
      client_id: MICROSOFT_ADMIN_CONSENT_CLIENT_ID,
    }

    popUp({
      path: `${MICROSOFT_CONSENT_BASE_URL}?${encodeQueryData(params)}`,
      onMessage: this.handlePostMessage,
    })
  }

  handlePostMessage = e => {
    const { onConnected, onConnectFailed } = this.props
    const success = e.data.status === 'success'

    this.setState({ pending: false }, () => {
      success ? onConnected() : onConnectFailed()
    })
  }

  render() {
    return (
      <div className="settings-global-calendar--connect">
        {Header}
        <div className="settings-global-calendar--connect content">
          <div className="settings-global-calendar--connect info">
            <OfficeLogo/>
            <p className="connect-title">Connect your teams' calendars to get started</p>
            <p className="connect-description">With one click, connect your entire teams' calendars to Drift and let leads and customers book times with each member directly through Drift chat.</p>
            <Button onClick={this.onCalendarConnectClick}>Connect Calendars</Button>
          </div>
          <img src={calendarConnectTeaseSrc} />
        </div>
      </div>
    )
  }

}

export default ConnectGlobalCalendar



// WEBPACK FOOTER //
// ./src/scripts/components/settings/GlobalCalendarSettings/ConnectGlobalCalendar/index.js